const config = {
	apiKey: 'AIzaSyACSxhVKFAuXglDmyikk4BnytDdLLF0QRA',
	authDomain: 'rooftop-app-a89cb.firebaseapp.com',
	databaseURL: 'https://rooftop-app-a89cb.firebaseio.com',
	storageBucket: 'rooftop-app-a89cb.appspot.com',
	messagingSenderId: '507372667910'
};
